/**
 * PrimaryCardholderSelect — dropdown to pick primary cardholder from current members.
 */

import type { BuddyGroupMemberView } from '../types/buddy-group';

interface PrimaryCardholderSelectProps {
  members: BuddyGroupMemberView[];
  value: string | null;
  onChange: (profileId: string | null) => void;
}

export function PrimaryCardholderSelect({ members, value, onChange }: PrimaryCardholderSelectProps) {
  return (
    <div className="space-y-1">
      <label className="text-sm font-medium text-foreground" htmlFor="primary-cardholder">
        Primary Cardholder
      </label>
      <select
        id="primary-cardholder"
        className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value || null)}
      >
        <option value="">None</option>
        {members.map((m) => (
          <option key={m.user_profile_id} value={m.user_profile_id}>
            {m.display_name}
          </option>
        ))}
      </select>
    </div>
  );
}
